// eslint-disable-next-line
import { HTTPValidationError } from '../sst/data-contracts';
import { ContentType, HttpClient, RequestParams } from '../sst/http-client';
import { Brand, Subscription, UserById } from './data-contracts';

export class ApiService<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  // private baseRoute = '/.netlify/functions';

  /**
   * Returns a message if api is healthy
   */
  // health = (args: { params?: RequestParams }) =>
  // TODO: Maybe add a health check that directs to sst status endpoint at some point to get a beautiful response body
  // this.request<HealthResponse, HTTPValidationError>({
  //   path: `${this.baseRoute}/health`,
  //   method: 'GET',
  //   secure: true,
  //   format: 'json',
  //   ...args.params,
  // });

  getBrands = (args: { params?: RequestParams }) =>
    this.request<Brand[], HTTPValidationError>({
      path: '/brands',
      method: 'GET',
      secure: true,
      format: 'json',
      ...args.params,
    });

  getUserById = (args: { userId: string; params?: RequestParams }) =>
    this.request<UserById, HTTPValidationError>({
      path: `/user/${args.userId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...args.params,
    });

  getUserByEmail = (args: { email: string; params?: RequestParams }) =>
    this.request<UserById, HTTPValidationError>({
      path: `/user/${args.email}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...args.params,
    });

  getActiveSubscriptions = (args: { userId: string | number; params?: RequestParams }) =>
    this.request<{ data: Subscription[] }, HTTPValidationError>({
      path: `/subscriptions/${args.userId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...args.params,
    });

  // Unused
  getAvailableSubscriptions = (args: { userId: string | number; params?: RequestParams }) =>
    this.request<{ data: Subscription[] }, HTTPValidationError>({
      path: `/subscriptions/${args.userId}/available_subscriptions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...args.params,
    });

  addSubscriptions = (args: { userId: string | number; data: string[]; params?: RequestParams }) =>
    this.request<{ status: string; code: number }, HTTPValidationError>({
      path: `/subscriptions/${args.userId}`,
      method: 'POST',
      type: ContentType.Json,
      body: args.data,
      secure: true,
      format: 'json',
      ...args.params,
    });

  deleteSubscriptions = (args: {
    userId: string | number;
    data: string[];
    params?: RequestParams;
  }) =>
    this.request<{ status: string; code: number }, HTTPValidationError>({
      path: `/subscriptions/${args.userId}`,
      type: ContentType.Json,
      method: 'DELETE',
      body: args.data,
      secure: true,
      format: 'json',
      ...args.params,
    });

  // TODO: I hope in my heart someday sst adds this. This note will be dleted once we generate
  // updateSubscriptions = (args: { userId: string; data: string[]; params?: RequestParams }) =>
  //   this.request<Subscription[], HTTPValidationError>({
  //     path: `${this.baseRoute}/subscriptions?userId=${args.userId}`,
  //     method: 'PUT',
  //     body: args.data,
  //     secure: true,
  //     format: 'json',
  //     ...args.params,
  //   });
}
